export const CONTINUE_WATCHING_ACTION = 'CONTINUE_WATCHING_ACTION';
export const CONTINUE_WATCHING_SUCCESS_ACTION =
  'CONTINUE_WATCHING_SUCCESS_ACTION';
export const CONTINUE_WATCHING_FAILURE_ACTION =
  'CONTINUE_WATCHING_FAILURE_ACTION';
